import { get, post, prefix } from '../index';
import { getDomainBaseUrl } from '@ugc-utils/domains';

const getAbuseReportReason = (): any => get(`${getDomainBaseUrl('catalog')}${prefix}/api/abuse/report/reason/setting`);

const getAbuseReportStatus = (referenceId): any =>
  get(`${getDomainBaseUrl('catalog')}${prefix}/api/abuse/report/${referenceId}/status`);

const postAbuseReport = ({ type, referenceId, data }) =>
  post(`${getDomainBaseUrl('catalog')}${prefix}/api/abuse/report/${type}/${referenceId}`, data);

export { getAbuseReportReason, getAbuseReportStatus, postAbuseReport };
